// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Button = require("@mui/material/Button").default;

function MM_cmp_click_counter(Props) {
  var title = Props.title;
  var match = React.useState(function () {
        return 0;
      });
  var setCnt = match[1];
  return React.createElement(Button, {
              onClick: (function (param) {
                  Curry._1(setCnt, (function (prev) {
                          return prev + 1 | 0;
                        }));
                }),
              children: "" + title + ". Clicked: " + String(match[0]) + ""
            });
}

var make = MM_cmp_click_counter;

exports.make = make;
/* react Not a pure module */
